import { render } from "./ModalContainer.vue?vue&type=template&id=33d0ba5c"
import script from "./ModalContainer.vue?vue&type=script&lang=js"
export * from "./ModalContainer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/florianroscher/Sites/simtschuk-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__